export const languageId = 'yaml';
